import { render, staticRenderFns } from "./InputPromoMobile.vue?vue&type=template&id=56ca9547&"
import script from "./InputPromoMobile.vue?vue&type=script&lang=js&"
export * from "./InputPromoMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports